import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaTooth, FaCalendarAlt, FaImage, FaUserMd, FaCommentMedical, FaMobileAlt, FaSearch, FaEuroSign, FaRocket, FaComments, FaCode, FaMapMarkerAlt } from 'react-icons/fa';
import Button from '../../components/Button';

const WebDentistasPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-abogados", text: "Página web barata para abogados" },
    { url: "/servicios/diseno-web-inmobiliarias", text: "Página web barata para inmobiliarias" },
    { url: "/servicios/diseno-web-psicologos", text: "Página web barata para psicólogos" },
    { url: "/precios", text: "Ver todos nuestros precios" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Capta pacientes mientras duermes o atiendes a otros",
      description: "Tu web trabaja 24/7, generando contactos incluso fuera del horario de la clínica. Muchos pacientes buscan dentistas por la noche, cuando tu clínica está cerrada."
    },
    {
      title: "Compite con las grandes cadenas dentales sin su presupuesto",
      description: "Las grandes clínicas invierten miles de euros en marketing. Con una web optimizada, puedes posicionarte localmente y competir por pacientes de tu zona geográfica."
    },
    {
      title: "Primera impresión que genera confianza",
      description: "El 83% de pacientes buscan su dentista online antes de llamar. Una web profesional transmite seguridad para tratamientos que generan miedo o ansiedad."
    },
    {
      title: "Optimiza tu agenda y reduce el tiempo al teléfono",
      description: "El sistema de citas online libera a tu personal de atender llamadas constantes, permitiéndoles enfocarse en los pacientes presentes en la clínica."
    },
    {
      title: "Diferénciate mostrando tu especialidad y trato personalizado",
      description: "Las cadenas dentales ofrecen servicios estandarizados. Tu web destaca tu trato personalizado y especialidades concretas frente a la competencia."
    },
    {
      title: "Inversión de rápido retorno",
      description: "Un solo tratamiento de implantes o estética dental captado a través de la web ya cubre varias veces el coste de desarrollo. La mayoría de nuestros clientes recuperan la inversión en menos de 2 meses."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaTooth />,
      title: "Catálogo de tratamientos que convence",
      description: "Presentamos tus servicios con imágenes, beneficios claros y llamadas a la acción, no solo listando tratamientos. Cada especialidad tiene su página optimizada."
    },
    {
      icon: <FaCalendarAlt />,
      title: "Sistema de citas sin comisiones",
      description: "Integramos un sistema de reserva online que conecta directamente con tu agenda, sin intermediarios ni comisiones por paciente como otras plataformas."
    },
    {
      icon: <FaImage />,
      title: "Antes y después que genera confianza",
      description: "Añadimos una galería de casos clínicos reales que demuestra tu experiencia y resultados, respetando siempre la privacidad de los pacientes."
    },
    {
      icon: <FaUserMd />,
      title: "Presentación del equipo que humaniza tu clínica",
      description: "La gente confía en personas, no en clínicas. Destacamos la formación y especialidad de cada profesional con un enfoque cercano y humano."
    },
    {
      icon: <FaSearch />,
      title: "Optimización local para pacientes de tu zona",
      description: "Configuramos tu web para que aparezca cuando alguien busca 'dentista cerca de mí' o 'dentista en [tu barrio/ciudad]', captando pacientes de proximidad."
    },
    {
      icon: <FaEuroSign />,
      title: "Sin costes ocultos ni sorpresas",
      description: "Precio final desde 300€ (pago único) y mantenimiento fijo de 20€/mes. Sin comisiones por paciente ni cargos extra por actualizaciones básicas."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para clínicas dentales que necesitan una web básica y profesional para empezar a captar pacientes.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=dentista-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por clínicas. Equilibrio perfecto entre precio y funcionalidades para atraer más pacientes.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=dentista-profesional',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para clínicas que quieren destacar en un mercado competitivo con más funcionalidades y mejor posicionamiento.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=dentista-avanzada',
      maintenanceFee: '20€/mes obligatorio incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Reunión para conocer tu clínica dental",
      description: "Conversamos sobre tus especialidades, valores, equipo y diferenciación. Te explicamos todo el proceso sin tecnicismos para que entiendas cada fase del desarrollo.",
      icon: <FaComments />
    },
    {
      number: 2,
      title: "Diseño y desarrollo en tiempo récord",
      description: "Creamos tu web con un diseño que transmite profesionalidad y confianza. Implementamos catálogo de tratamientos, sistema de citas y otros elementos clave para clínicas dentales.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y formación básica",
      description: "Activamos tu web y te enseñamos a gestionar citas y actualizar contenidos sin complicaciones. Te damos consejos para promocionarla y comenzar a recibir pacientes online.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Web especializada en el sector dental",
      us: true,
      others: false
    },
    {
      label: "Precio final sin comisiones por paciente",
      us: true,
      others: false
    },
    {
      label: "Sistema de citas sin costes mensuales",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Mantenimiento sin subidas sorpresa",
      us: true,
      others: false
    },
    {
      label: "Soporte directo y sin intermediarios",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Después de gastar mucho dinero en directorios y plataformas dentales con resultados mediocres, decidí probar con una web propia. Desde que tengo mi página con Web a Bajo Coste, recibo entre 10 y 15 solicitudes de cita nuevas cada mes, y nuestra agenda está mucho más optimizada gracias al sistema de reservas.",
    author: "Dra. Elena Martínez",
    position: "Directora Clínica",
    company: "Centro Dental Sonrisa",
    avatar: "/servicios/testimonios/dentista.webp"
  };
  
  // FAQs específicas para dentistas
  const faqs = [
    {
      question: "¿Por qué necesito una web propia si ya estoy en portales dentales?",
      answer: "Los portales dentales son útiles pero tienen limitaciones importantes: dan más visibilidad a quien paga más (no necesariamente a los mejores profesionales), cobran comisiones por paciente (generalmente entre 10-25€ por cada nuevo paciente), limitan tu capacidad de diferenciación, y los pacientes comparan directamente por precio. Una web propia te permite destacar tus valores únicos, captar pacientes sin comisiones recurrentes, y construir tu propia marca digital, complementando perfectamente tu presencia en portales. La mayoría de nuestras clínicas clientes mantienen su presencia en portales pero reciben el 60-70% de sus nuevos pacientes a través de su web propia.",
      category: "Estrategia"
    },
    {
      question: "¿Cómo funciona el sistema de citas online?",
      answer: "A diferencia de plataformas que cobran mensualidades o comisiones por paciente, nuestro sistema de citas (incluido en los planes Profesional y Premium) funciona sin costes adicionales. El paciente selecciona el tratamiento deseado, elige fecha y hora según la disponibilidad mostrada, completa sus datos básicos, y recibe confirmación automática. La cita aparece directamente en tu sistema de gestión a través de una integración API o, si prefieres un sistema más sencillo, mediante notificaciones por email/WhatsApp. El sistema respeta tus horarios y tiempos de tratamiento predefinidos, evitando solapamientos o reservas fuera de horario laboral.",
      category: "Funcionalidades"
    },
    {
      question: "¿La web me ayudará a atraer más pacientes o es solo imagen?",
      answer: "Desarrollamos webs específicamente diseñadas para convertir visitantes en pacientes. Incluimos: optimización SEO local para aparecer cuando buscan 'dentista en [tu zona]', estructura persuasiva que destaca tratamientos más rentables, elementos de credibilidad como antes/después y testimonios, llamadas a la acción estratégicas, y conexión con Google Business Profile. Además, proporcionamos consejos de marketing dental tras el lanzamiento. El 87% de nuestras clínicas clientes reportan un aumento del 30-50% en nuevos pacientes durante los primeros tres meses con la nueva web.",
      category: "Resultados"
    },
    {
      question: "¿Tendré que encargarme yo mismo del mantenimiento técnico?",
      answer: "Absolutamente no. El mantenimiento técnico está completamente cubierto por la cuota mensual obligatoria de 20€, que incluye: actualizaciones de seguridad, copias de seguridad periódicas, certificado SSL renovado automáticamente, alojamiento y dominio, correcciones técnicas inmediatas si algo no funciona, y pequeñas modificaciones de contenido (horarios, datos, etc). Los cambios más grandes (como añadir nuevas secciones) tienen un coste adicional muy razonable. Nos encargamos de todos los aspectos técnicos para que puedas centrarte en tu especialidad: atender pacientes.",
      category: "Mantenimiento"
    },
    {
      question: "¿Puedo mostrar casos clínicos reales respetando la confidencialidad?",
      answer: "Sí, y es muy recomendable hacerlo. Implementamos diferentes opciones según tus preferencias: fotos de antes/después solo de la zona bucal (sin mostrar el rostro completo), casos con consentimiento firmado por el paciente (te proporcionamos un modelo), o testimonios en forma de reseñas con iniciales. La galería de casos clínicos es uno de los elementos más efectivos para generar confianza, especialmente en tratamientos estéticos o complejos como implantes y ortodoncias. Según nuestras estadísticas, las clínicas que muestran casos reales convierten un 37% más de visitantes en pacientes.",
      category: "Contenido"
    },
    {
      question: "¿En cuánto tiempo estará lista mi web dental?",
      answer: "El tiempo de desarrollo es de 7-10 días desde la aprobación del diseño inicial. Este plazo incluye: diseño personalizado según tu imagen de marca, implementación del catálogo de tratamientos, configuración del sistema de citas (en planes que lo incluyen), optimización SEO local y configuración técnica completa. Necesitaremos que nos proporciones información básica sobre tu clínica, servicios y equipo. El 95% de nuestros proyectos dentales se entregan en el plazo prometido, permitiéndote comenzar a captar pacientes rápidamente.",
      category: "Plazos"
    }
  ];

  const founderMessage = "Tras desarrollar webs para varias clínicas dentales, hemos identificado que los pacientes buscan información específica antes de elegir dentista: tratamientos, costes aproximados y opiniones de otros pacientes. Nuestras webs para odontólogos están diseñadas para destacar exactamente estos aspectos y generar nuevas consultas.";
  
  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para dentistas
      pageTitle="Página Web para Clínicas Dentales desde 300€ | Atrae Nuevos Pacientes"
      pageDescription="Diseñamos webs para dentistas que generan nuevos pacientes. Sistema de citas online, presentación de tratamientos y optimización SEO local incluidos."
      pageKeywords="página web barata dentistas, diseño web clínica dental, web para odontólogos, web económica dentistas, página web dental"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-dentistas"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para clínicas dentales desde 300€ (sin comisiones por paciente)"
      heroSubtitle="Atrae nuevos pacientes y gestiona citas online sin intermediarios. Diseño profesional adaptado al sector dental y listo en solo 10 días."
      heroImage="/servicios/tipo-cliente/hero-dentistas.webp"
      badges={['Desde 300€ (pago único)', 'Sistema de citas incluido', 'Optimización para pacientes locales', 'Mantenimiento 20€/mes']}
      heroCTAText="Consulta gratuita sin compromiso"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de clínica dental"
      pricingSubtitle="Elige el plan que mejor se adapte a tu clínica. Todos incluyen soporte técnico y mantenimiento obligatorio por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestras webs son ideales para dentistas?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Jaime Vela"
            founderTitle="Co-fundador y Director de Marketing"
            avatarSrc="/sobre nosotros/foto-jaime.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Creamos tu web dental: simple, rápido y sin complicaciones"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué las clínicas dentales nos eligen?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="¿Qué conseguirás con una web profesional para tu clínica?"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para dentistas"
      faqCategories={["Estrategia", "Funcionalidades", "Resultados", "Mantenimiento", "Contenido", "Plazos"]}
      faqs={faqs}
      
      ctaTitle="Potencia tu clínica dental con presencia online profesional"
      ctaDescription="Comienza a captar pacientes de alta calidad por internet. Tu web dental trabaja para ti 24/7."
      ctaButtonText="Reservar consulta gratuita"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebDentistasPage; 

